var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-up-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6692 6.77614L4.93145 12.5139L3.98865 11.5711L9.72637 5.83333H4.66919V4.5H12.0025V11.8333H10.6692V6.77614Z",
    fill: "#5784F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUpIcon);
export default __webpack_public_path__ + "static/media/ArrowRightUpIcon.52e4046ebc2bdac03be9b2b2aba07e32.svg";
export { ForwardRef as ReactComponent };